module.exports = __webpack_public_path__ + "static/media/QualityPic04.689d3e8a.jpg";